import * as React from 'react';

import { toRegularInfrastructureItems } from '../helpers/mappers';
import { IRegularInfrastructureData } from '../../../types/map';
import { trackFullscreenShow } from '../analytics';

export const useFullscreen = (
  TAInfrastructureTypeRef: React.MutableRefObject<string | undefined>,
  regularInfrastructureTypeRef: React.MutableRefObject<string | undefined>,
  regularInfrastructureMap: Map<number, IRegularInfrastructureData>,
) => {
  const [isFullscreen, setFullscreenState] = React.useState(false);

  const regularInfrastructureItems = React.useMemo(
    () => toRegularInfrastructureItems(regularInfrastructureMap),
    [regularInfrastructureMap],
  );

  const handleFullscreenEnter = React.useCallback(() => {
    setFullscreenState(true);
    trackFullscreenShow(
      true,
      regularInfrastructureItems,
      getInfrastructureType(TAInfrastructureTypeRef, regularInfrastructureTypeRef),
    );
  }, [regularInfrastructureItems]);

  const handleFullscreenExit = React.useCallback(() => {
    setFullscreenState(false);
    trackFullscreenShow(
      false,
      regularInfrastructureItems,
      getInfrastructureType(TAInfrastructureTypeRef, regularInfrastructureTypeRef),
    );
  }, [regularInfrastructureItems]);

  return {
    isFullscreen,
    handleFullscreenEnter,
    handleFullscreenExit,
  };
};

function getInfrastructureType(
  TAInfrastructureTypeRef: React.MutableRefObject<string | undefined>,
  regularInfrastructureTypeRef: React.MutableRefObject<string | undefined>,
) {
  return TAInfrastructureTypeRef.current || regularInfrastructureTypeRef.current;
}
